import React from 'react';
import PropTypes from 'prop-types';

export const withShimmer = (WrappedComponent, Shimmer) => {
  const ShimmerWrapper = ({ showShimmer, ...props }) => {
    if (showShimmer) {
      return <Shimmer />;
    }

    return <WrappedComponent {...props} />;
  };

  ShimmerWrapper.propTypes = {
    showShimmer: PropTypes.bool,
  };

  ShimmerWrapper.defaultProps = {
    showShimmer: false,
  };

  return ShimmerWrapper;
};

